module.exports = __webpack_public_path__ + "media/images/star-ec0b3b998ed79071d90419e43991d142.svg";